(function () {
  function getStickyButton() {
    return document.querySelector(
      '.Vtl-StickyAddToCart__AddToCartButton, #bundle-sticky_add_to_cart-root .Vtl-StickyAddToCart__AddToCartButton'
    );
  }

  function getMainAddToCartButton() {
    var selectors = [
      '[data-revahs-add-to-cart]',
      'button[type="submit"][name="add"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form__cart-submit',
      '[data-pf-type="ProductATC"] button',
      '[data-pf-type="AddToCart"] button'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }

    return null;
  }

  function bindStickyButton() {
    var stickyBtn = getStickyButton();
    if (!stickyBtn || stickyBtn.dataset.revahsBound === 'true') return;

    stickyBtn.dataset.revahsBound = 'true';

    stickyBtn.addEventListener('click', function (event) {
      var mainBtn = getMainAddToCartButton();

      event.preventDefault();
      event.stopPropagation();

      if (!mainBtn) {
        console.warn('REVAHS: hoofd add-to-cart knop niet gevonden.');
        return;
      }

      if (mainBtn.disabled) return;

      mainBtn.click();
    });
  }

  document.addEventListener('DOMContentLoaded', bindStickyButton);
  document.addEventListener('shopify:section:load', bindStickyButton);

  var observer = new MutationObserver(function () {
    bindStickyButton();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();